import React from 'react';
import Contact from '../components/contact';
import Footer from '../components/footer';
import People from '../components/people';
import '../styles/home.css';

function people() {
    window.scrollTo(0, 0);
    return (
        <div className='people'>
            <div style={{ marginTop: '100px'}}>
                <People />
            </div>
            <Contact />
            <Footer />
        </div>
    )
}

export default people